import React, { FC, Fragment, useState } from "react";
import { Button, createStyles, makeStyles, Theme, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import InfoDialog, { ContentProps } from "./CustomerTypeInfoDialog/InfoDialog";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const useStyles = (mobile: boolean) => makeStyles((theme: Theme) =>
    createStyles({
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.primary.main,
        },
        header: {
            color: theme.palette.primary.main
        },
        bold: {
            fontWeight: "bold",
            textTransform: "none"
        },
        title: {
            padding: 0
        },
        content: {
            padding: mobile ? theme.spacing(2) : theme.spacing(4),
            "& .MuiTypography": {
                fontFamily: "Gotham Narrow"
            }
        },
        infoButton: {
            backgroundColor: "transparent",
            display: "flex",
            justifyContent: "flex-start",
            textTransform: "none",
            textDecoration: "none",
            marginTop: "24px !important",
            marginBottom: "24px !important",
        },
        buttonText: {
            paddingLeft: theme.spacing(0),
            paddingRight: theme.spacing(1),
            color: theme.palette.primary.main,
            textAlign: "left"
        },
    })
);

const Content: FC<ContentProps> = (props) => {
    const { translation, note_number } = props;
    const theme = useTheme();
    const fullscreen = useMediaQuery(theme.breakpoints.down("md"));
    const classes = useStyles(fullscreen)();
    const [dialogOpen, setDialogOpen] = useState(false);
    return (
        <>
            <Button
                id="info-dialog-button"
                size={"medium"}
                disableRipple={true}
                className={classes.infoButton}
                color="primary"
                onClick={() => setDialogOpen(true)} >
                <Typography className={classes.buttonText}>
                    {note_number === 1 ? translation.limitedInternetReservationNote : null}
                    {note_number === 2 ? translation.limitedInternetReservationNote2 : null}
                </Typography>
                <InfoOutlinedIcon />
            </Button>
            <InfoDialog
                id="info-dialog"
                open={dialogOpen}
                translation={translation}
                closeDialog={() => setDialogOpen(false)}
            >
                <Fragment>
                    <Typography
                        paragraph
                        className={classes.bold}
                    >
                        {note_number === 1 ? (translation.limitedInternetBookingTitle + ':') : null}
                        {note_number === 2 ? (translation.limitedInternetBookingTitle2 + ':') : null}
                    </Typography>

                    <Typography
                        component="span"
                        paragraph
                        display="block"
                    >
                        {note_number === 1 ? translation.limitedInternetBookingDetails : null}
                        {note_number === 2 ? translation.limitedInternetBookingDetails2 : null}
                    </Typography>
                </Fragment>
            </InfoDialog>
        </>
    );
};

export default Content;
